<!--

@Author Érik
-->

<template>
  <div class="modalEditProfile">
    <md-button class="md-primary buttonEdit" @click="activeEdit = true">
      Editar
      <md-icon class="iconEdit">edit</md-icon>
    </md-button>

    <md-dialog class="modalEdit" :md-active.sync="activeEdit">
      <md-dialog-title>
        Editar
      </md-dialog-title>

      <md-dialog-content class="modalForm">
        <md-field class="input">
          <md-input v-model="form.cover" placeholder="Imagem de fundo" maxlength="250"></md-input>
          <span class="md-helper-text">Imagem de fundo (link)</span>
        </md-field>

        <md-field class="input">
          <md-input v-model="form.avatar" placeholder="Avatar" maxlength="250"></md-input>
          <span class="md-helper-text">Avatar* (link)</span>
        </md-field>

        <md-field class="input">
          <md-input v-model="form.name" placeholder="Nome" maxlength="25"></md-input>
          <span class="md-helper-text">Nome*</span>
        </md-field>

        <md-field class="input">
          <md-input v-model="form.surname" placeholder="Sobrenome" maxlength="30"></md-input>
          <span class="md-helper-text">Sobrenome</span>
        </md-field>

        <md-field class="input">
          <label>Descrição</label>
          <md-textarea class="textareaStory" v-model="form.description" placeholder="Descrição" maxlength="250"></md-textarea>
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-rised" @click="activeEdit = false">
          Cancelar
        </md-button>

        <md-button class="md-raised md-primary" :md-ripple="false" @click="submit" :disabled="submitted != false || form.name == ''">
          Enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import call from '@/api/calls';

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  data() {
    return {
      activeEdit: false,
      form: {
        cover: null,
        avatar: null,
        name: null,
        surname: null,
        description: null
      },
      submitted: false
    }
  },
  computed: {
    surname() {
      let user = this.$route.params.user
      if(!user.name) {
        return user.fullName;
      }
      else if(!user.fullName) {
        return '';
      }
      else return user.fullName.replace(user.name, '').trim();
    },
    fullName() {
      let form = this.form
      if(!form.name) {
        return form.surname;
      }
      else if(!form.surname) {
        return form.name;
      }
      else return form.name + ' ' + form.surname;
    },
    user() {
      return JSON.parse(localStorage.getItem('user'));
    }
  },
  created() {
    this.loadCurrent()
  },
  methods: {
    loadCurrent() {
      let user = this.$route.params.user;
      this.form.cover = user.bannerImg,
      this.form.avatar = user.profileImg,
      this.form.name = user.name,
      this.form.surname = this.surname,
      this.form.description = user.description
    },
    submit() {
      this.submitted = true;
      let newProfile = {
        id: this.$route.params.id,
        profileImg: this.form.avatar,
        bannerImg: this.form.cover,
        name: this.form.name,
        fullName: this.fullName,
        description: this.form.description
      }
      return call.profile.edit(newProfile, this.user.id)
      .then(profile => {
        this.activeEdit = false
        // console.log('Edited!', profile);
        // talvez repassar a atualização pro perfil?
        // ^ pra isso precisa setar como returning: true no controller...
        if(profile[0] == 1) {
          // update session
          call.auth.updateUserSession(newProfile.id, newProfile)
          .then(() => this.$router.push({ name: "refreshSession" }))
          .catch(error => {
            log(error, "submit().updateUserSession()", { id: newProfile.id });
            return this.$router.go();
          })
        }
        else
          this.error = profile
      })
      .catch(error => {
        this.submitted = error;
        log(error, "submit()", null);
        return
      })
    }
  },
}
</script>

<style scoped>
/* .md-dialog {
  width: 100%;
  padding: 0 5%;
} */

.modal-friends {
  text-align: center;
  /* align-items: center;
  justify-content: center; */
}

.modalEdit {
  padding: 0 0.5px;
  height: auto;
}

.modalForm {
  min-width: 40vw;
}

.buttonEdit {
  position: relative;
  display: block;
  margin: auto;
  margin-bottom: 8px;
  border-radius: 50px;
}

.iconEdit {
  height: 2px;
  margin-left: 5%;
  margin-bottom: 4%;
  font-size: 18px;
}

/* .md-dialog-title{
  margin-bottom: 0
} */

.titleModal {
  position: absolute;
  text-align: center;
  font-size: 20px;
  top: 20px;
  left: 25px;
  bottom: 0px;
}

#exitModal {
  top: 0;
}

/* .inputModal {
  width: 100%
} */

.inputEdit {
  --pure-material-safari-helper1: rgb(
    var(--pure-material-primary-rgb, 33, 150, 243)
  );
  position: relative;
  display: inline-block;
  padding-top: 8px;
  font-family: var(
    --pure-material-font,
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  line-height: 1.5;
  /* overflow: hidden; */
}

/* Input, Textarea */
.inputEdit > input,
.inputEdit > textarea {
  box-sizing: border-box;
  margin: 0;
  padding: 15px 13px 15px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
  border: 1px solid #ccc;
}

/* Span */
.inputEdit > input + span,
.inputEdit > textarea + span {
  position: absolute;
  top: 0;
  left: 15px;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  /* width: 100%; */
  max-height: 50%;
  /* padding-left: 15px; */
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 80%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

.inputEdit > input:not(:focus):placeholder-shown + span,
.inputEdit > textarea:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 68px;
}

/* Focus */
.inputEdit input:focus + span,
.inputEdit input:not(:placeholder-shown) + span,
.inputEdit textarea:focus + span,
.inputEdit textarea:not(:placeholder-shown) + span {
  background-color: #fff;
  padding: 3px;
}

.inputEdit > textarea {
  min-height: 80px;
  max-height: 160px;
  resize: vertical;
}

.inputCover {
  display: flex;
  width: 40vw;
  margin: 0 auto;
  text-align: center;
}

.inputAvatar {
  display: flex;
  width: 40vw;
  margin: 0 auto;
  text-align: center;
}

.inputName {
  display: flex;
  width: 40vw;
  margin: 0 auto;
  text-align: center;
}

.inputDescription {
  display: flex;
  width: 40vw;
  min-height: 80px;
  /* height: 40vh; */
  margin: 0 auto;
  /* margin-bottom: 5%; */
  text-align: center;
}

.submit {
  /* display: flex;
  position: relative; */
  /* margin: 5%;
  margin-right: 5vw; */
  float: right;
  /* right: 0; */
}
</style>
